import React , { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../styles/SidebarCustomer.css";
import { FaHome, FaBell, FaPlus, FaBuilding, FaUserEdit, FaSignOutAlt , FaCreditCard, FaBars, FaComments } from "react-icons/fa";
import ChatWidget from './ChatWidget';

const SidebarCustomer = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openChat, setOpenChat] = useState(false);
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const companyId = user?.company?.id;
  
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
  };
  
console.log('STATE → openChat:', openChat, 'companyId:', companyId);
  return (
        <>
    <button className="sidebar-toggle-btn" onClick={() => setOpen(!open)}>
      <FaBars />
    </button>
    <aside className={`sidebar-customer ${open ? "open" : ""}`}>
      <nav className="sidebar-navC">
        <NavLink to="/customer/dashboard" className="sidebar-linkC" onClick={() => setOpen(false)}>
          <FaHome /> Dashboard
        </NavLink>
        <NavLink to="/customer/notifications" className="sidebar-linkC" onClick={() => setOpen(false)}>
          <FaBell /> Notifications
        </NavLink>
        <NavLink to="/customer/audits" className="sidebar-linkC" onClick={() => setOpen(false)}>
          <FaPlus /> Audits
        </NavLink>
        <NavLink to="/customer/companie" className="sidebar-linkC" onClick={() => setOpen(false)}>
          <FaBuilding /> Company
        </NavLink>
        <NavLink to="/customer/profile" className="sidebar-linkC" onClick={() => setOpen(false)}>
          <FaUserEdit /> Update Profile
        </NavLink>
          <NavLink to="/customer/payment" className="sidebar-linkC" onClick={() => setOpen(false)}>
          <FaCreditCard /> Payment
        </NavLink>
        <button onClick={handleLogout} className="sidebar-linkC logout-btnC" >
          <FaSignOutAlt /> Logout
        </button>
      </nav>
      <button onClick={() => { setOpenChat(true);}} className="sidebar-linkkc">
        <FaComments /> Chat
     </button>
    </aside>
    {openChat && companyId && (
      <ChatWidget companyId={companyId} onClose={() => setOpenChat(false)} />
    )}
    </>
  );
};
export default SidebarCustomer;
